import React, { PureComponent } from "react";
import { UISref } from "@uirouter/react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { Icon } from "../../../../Common/Icon";
import { pushToBreadcrumbStack } from "../../../../../helpers/urlHelpers";

class BillOfLadingLinkCell extends PureComponent {
  static propTypes = {
    breadcrumbStack: PropTypes.array,
    className: PropTypes.string,
    customerId: PropTypes.string,
    customerPOId: PropTypes.string,
    isShipmentAvailable: PropTypes.bool,
    loadId: PropTypes.string
  };

  static defaultProps = {
    breadcrumbStack: [],
    className: "",
    customerId: "",
    customerPOId: "",
    isShipmentAvailable: false,
    loadId: ""
  };

  state = {
    displayPaperTooltip: false,
    displayTruckTooltip: false
  };

  handleStopPropagation = event => event.stopPropagation();

  handlePaperMouseEnter = () => this.setState({ displayPaperTooltip: true });

  handlePaperMouseLeave = () => this.setState({ displayPaperTooltip: false });

  handleTruckMouseEnter = () => this.setState({ displayTruckTooltip: true });

  handleTruckMouseLeave = () => this.setState({ displayTruckTooltip: false });

  render() {
    const { customerId, customerPOId, breadcrumbStack, loadId } = this.props;
    const millOrdersBreadcrumbStack = pushToBreadcrumbStack([...breadcrumbStack], "MillOrders");
    const billOfLadingBreadcrumbStack = pushToBreadcrumbStack([...breadcrumbStack], "BillOfLadingList");

    return (
      <div role="cell" className={classNames("sorted-list__data bill-of-lading-cell --center", this.props.className)}>
        <UISref to="MillOrders" params={{ customerId, customerPOId, loadId, breadcrumbStack: millOrdersBreadcrumbStack }}>
          <button
            className="button__actions --active --truck"
            onClick={this.handleStopPropagation}
            onMouseEnter={this.handleTruckMouseEnter}
            onMouseLeave={this.handleTruckMouseLeave}>
            <Icon id="paper-roll" className="button__actions-icon" />
            {this.state.displayTruckTooltip && <span className="header-tooltip">{i18n.t("tooltip.truck")}</span>}
          </button>
        </UISref>

        {this.props.isShipmentAvailable && (
          <UISref to="BillOfLadingList" params={{ customerId, customerPOId, loadId, breadcrumbStack: billOfLadingBreadcrumbStack }}>
            <button
              className="button__actions --active"
              onClick={this.handleStopPropagation}
              onMouseEnter={this.handlePaperMouseEnter}
              onMouseLeave={this.handlePaperMouseLeave}>
              <Icon id="truck" className="button__actions-icon" />
              {this.state.displayPaperTooltip && <span className="header-tooltip">{i18n.t("tooltip.paper")}</span>}
            </button>
          </UISref>
        )}

        {!this.props.isShipmentAvailable && (
          <button className="button__actions --inactive">
            <Icon id="truck" className="button__actions-icon" />
          </button>
        )}
      </div>
    );
  }
}

export default BillOfLadingLinkCell;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/List/Loads/BillOfLadingLinkCell.js